import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { HERITAGE } from '../data/mock';

export const HeritageTimeline = () => {
  const [ref, inView] = useInView({ threshold: 0.1 });

  return (
    <section id="heritage" ref={ref} className="relative py-28 bg-[#FAFAF7]">
      {/* Subtle pattern */}
      <div className="absolute inset-0 opacity-[0.02]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, #0D1B2A 1px, transparent 0)', backgroundSize: '40px 40px' }} />

      <div className="max-w-7xl mx-auto px-6 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="mb-20"
        >
          <span className="text-[#D4952B] text-sm font-semibold tracking-[0.2em] uppercase">Our Journey</span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0D1B2A] mt-3 leading-tight">
            Four Decades of Innovation
          </h2>
          <p className="text-2xl md:text-3xl text-[#0D1B2A]/30 font-semibold mt-2 font-['Noto_Sans_Arabic']">إرثنا</p>
        </motion.div>

        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-[#D4952B]/40 via-[#D4952B]/20 to-transparent hidden md:block" />
          <div className="absolute left-8 top-0 bottom-0 w-px bg-gradient-to-b from-[#D4952B]/40 via-[#D4952B]/20 to-transparent md:hidden" />

          {HERITAGE.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 + i * 0.15 }}
              className={`relative flex items-start gap-8 mb-16 last:mb-0 ${
                i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
              }`}
            >
              {/* Dot */}
              <div className="absolute left-8 md:left-1/2 w-4 h-4 rounded-full bg-[#D4952B] border-4 border-[#FAFAF7] shadow-lg shadow-amber-900/20 -translate-x-1/2 z-10 mt-2" />

              {/* Content */}
              <div className={`ml-16 md:ml-0 md:w-[45%] ${
                i % 2 === 0 ? 'md:pr-12 md:text-right' : 'md:pl-12'
              }`}>
                <div className="bg-white rounded-2xl p-8 shadow-sm border border-[#0D1B2A]/5 hover:shadow-lg hover:border-[#D4952B]/20 transition-all duration-500 group">
                  <div className="inline-block px-4 py-1.5 bg-[#0D1B2A] text-[#E8B84A] text-sm font-bold rounded-lg mb-4">
                    {item.era}
                  </div>
                  <p className="text-[#1C2B33]/80 text-sm leading-relaxed">
                    {item.milestone}
                  </p>
                  <p className="text-[#1C2B33]/40 text-xs mt-3 leading-relaxed" dir="rtl">
                    {item.milestoneAr}
                  </p>
                </div>
              </div>

              {/* Spacer for alternating layout */}
              <div className="hidden md:block md:w-[45%]" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
